import "./featuredprod.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper";
import { images } from "../../constants";
import { AiOutlineHeart } from "react-icons/ai";

const FeaturedProd = () => {
  return (
    <section className="app_featured-prod">
      <h3>FEATURED PROD</h3>
      <Swiper
        slidesPerView={4}
        spaceBetween={30}
        navigation
        autoplay={{
          delay: 2500,
          disableOnInteraction: true,
        }}
        modules={[Autoplay, Navigation]}
        className="mySwiper"
      >
        <SwiperSlide className="prod-slide">
          <div className="app_prod-item">
            <img src={images.FeaturedProd1} alt="prod 1" />
            <p>Well M Joy Care</p>
            <h4>₹ 2,399</h4>
            <div className="app_prod-btn-div">
              <AiOutlineHeart />
              <button>Add To Cart</button>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="prod-slide">
          <div className="app_prod-item">
            <img src={images.FeaturedProd2} alt="prod 2" />
            <p>Garbh Sanskar</p>
            <h4>₹ 2,500</h4>
            <div className="app_prod-btn-div">
              <AiOutlineHeart />
              <button>Add To Cart</button>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="prod-slide">
          <div className="app_prod-item">
            <img src={images.FeaturedProd3} alt="prod 3" />
            <p>Yogi Fi Smart Yoga Mat</p>
            <h4>₹ 12,500</h4>
            <div className="app_prod-btn-div">
              <AiOutlineHeart />
              <button>Add To Cart</button>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="prod-slide">
          <div className="app_prod-item">
            <img src={images.FeaturedProd4} alt="prod 4" />
            <p>Prega Eva Kit</p>
            <h4>₹ 23,999</h4>
            <div className="app_prod-btn-div">
              <AiOutlineHeart />
              <button>Add To Cart</button>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="prod-slide">
          <div className="app_prod-item">
            <img src={images.FeaturedProd5} alt="prod 5" />
            <p>Garbh Sanskar</p>
            <h4>₹ 23,999</h4>
            <div className="app_prod-btn-div">
              <AiOutlineHeart />
              <button>Add To Cart</button>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="prod-slide">
          <div className="app_prod-item">
            <img src={images.FeaturedProd6} alt="prod 6" />
            <p>Arouba - Consultant</p>
            <h4>₹ 23,999</h4>
            <div className="app_prod-btn-div">
              <AiOutlineHeart />
              <button>Add To Cart</button>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </section>
  );
};

export default FeaturedProd;
